import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import "./Report.css";
import "../../index.css";
import { MantineReactTable } from "mantine-react-table";
import * as XLSX from "xlsx";
import axios from "axios";
import {
  HEADERS,
  GetUser,
  getDepId,
  getOrgId,
  GetLeaveType,
  LeaveReport,
} from "../api";
import { Link } from "react-router-dom";

export default function EmployeeLeaveRequest() {
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserData, setSelectedUserData] = useState([]);
  const [leaveType, setLeaveType] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedLeaveType, setSelectedLeaveType] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);

  const handleStartDateChange = (event) => {
    const dateValue = event.target.value;
    setStartDate(dateValue ? new Date(dateValue) : null);
  };

  const handleEndDateChange = (event) => {
    const dateValue = event.target.value;
    setEndDate(dateValue ? new Date(dateValue) : null);
  };

  useEffect(() => {
    const fetchData = async () => {
      const OrgID = getOrgId();
      const DepId = getDepId();
      try {
        const requestData = { org_id: OrgID, dept_id: DepId };
        const response = await axios.post(GetUser, requestData, {
          headers: HEADERS,
        });
        if (response.data.response_code === "0000") {
          setAllUsers(response.data.data);
        } else {
          console.error("Error fetching users. Please try again later.");
        }
      } catch (error) {
        console.error("An error occurred while fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchLeaveTypes = async () => {
      const OrgID = getOrgId();
      try {
        const requestData = { org_id: OrgID };
        const response = await axios.post(GetLeaveType, requestData, {
          headers: HEADERS,
        });

        if (response.data.response_code === "0000") {
          setLeaveType(response.data.data);
        } else {
          // console.error('Error fetching leave type. Please try again later.');
        }
      } catch (error) {
        // console.error('An error occurred while fetching leave type:', error);
      }
    };

    fetchLeaveTypes();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      let userIdToSend = selectedUserId;
      if (selectedUserId === "all") {
        userIdToSend = null;
      }

      const OrgID = getOrgId();
      const DepId = getDepId();

      try {
        const requestData = {
          org_id: OrgID,
          dept_id: DepId,
          user_id: userIdToSend,
          leave_type: selectedLeaveType,
          start_date: startDate ? startDate.toISOString().split("T")[0] : null,
          end_date: endDate ? endDate.toISOString().split("T")[0] : null,
        };

        const response = await axios.post(LeaveReport, requestData, {
          headers: HEADERS,
        });

        if (response.data.response_code === "0000") {
          setSelectedUserData(response.data.data);
        } else {
          console.error(
            "Error fetching user Leave History. Please try again later."
          );
          setSelectedUserData([]);
        }
      } catch (error) {
        console.error("An error occurred while fetching data:", error);
        setSelectedUserData([]);
      }
    };

    fetchData();
  }, [selectedUserId, selectedLeaveType, startDate, endDate]);

  const tableData = selectedUserData.map((datas) => ({
    user_name: datas.user_name,
    leave_type_name: datas.leave_type_name,
    from_date: datas.from_date,
    to_date: datas.to_date,
    days_off: datas.days_off,
    department_name: datas.department_name,
    leave_approved_by: datas.leave_approved_by,
  }));

  const tableColumns = [
    { accessorKey: "user_name", header: "Employee Name" },
    { accessorKey: "leave_type_name", header: "Leave Type" },
    { accessorKey: "from_date", header: "Begin Date" },
    { accessorKey: "to_date", header: "End Date" },
    { accessorKey: "days_off", header: "Days Off" },
    { accessorKey: "department_name", header: "Department Name" },
    { accessorKey: "leave_approved_by", header: "Approval Name" },
  ];

  const handleSelectChange = (e) => {
    setSelectedUserId(e.target.value === "all" ? null : e.target.value);
  };
  const handleLeaveTypeChange = (event) => {
    setSelectedLeaveType(event.target.value);
  };

  const handleDownloadXLSX = () => {
    const worksheetData = [tableColumns.map((col) => col.header)];
    tableData.forEach((data) => {
      worksheetData.push(tableColumns.map((col) => data[col.accessorKey]));
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leave History");
    XLSX.writeFile(workbook, "leave-history-report.xlsx");
  };

  const paginatedData = tableData.slice(page * pageSize, (page + 1) * pageSize);
  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, tableData.length);
  const totalRows = tableData.length;

  const handlePageChange = (newPage) => setPage(newPage);

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0); // Reset to first page when page size changes
  };
  return (
    <div className="">
      <span className="breadcrumb d-flex gap-2">
        <Link className="previou-link text-decoration-none" to="/report">
          Report
        </Link>
        <span>/</span>
        <span className="current-link text-decoration-none">Leave Report</span>
      </span>
      <div className="row">
        <div className="col-md-12">
          <div>
            <span className="title">Employee Leave History Report</span>
          </div>
          <Card className="p-4 mt-3">
            <span>
              <strong>Search Parameters</strong>
            </span>
            <hr className="hr-line" />
            <div className="row d-flex">
              <div className="col-md-3">
                <label style={{ minWidth: 120 }}>Employees</label>
                <select className="form-select" onChange={handleSelectChange}>
                  <option value="" disabled>
                    Select User
                  </option>
                  <option value="all">All</option>
                  {allUsers.map((user, index) => (
                    <option key={index} value={user.user_id}>
                      {`${user.first_name} ${user.last_name}`} (
                      {user.employee_code})
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label style={{ minWidth: 120 }}>Leave Type</label>
                <select
                  className="form-select"
                  onChange={handleLeaveTypeChange}
                >
                  <option value="" disabled selected>
                    Select Leave Type
                  </option>
                  {leaveType.map((type) => (
                    <option key={type.leave_type_id} value={type.leave_type_id}>
                      {type.leave_type_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3">
                <label style={{ minWidth: 146 }}>Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={handleStartDateChange}
                />
              </div>
              <div className="col-md-3">
                <label style={{ minWidth: 146 }}>End Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={handleEndDateChange}
                />
              </div>
            </div>
          </Card>
        </div>
      </div>
      <div className="row mt-4 pb-3">
        <div className="d-flex justify-content-between pb-3">
          <span className="title">Leave History</span>
          <button className="button-outline" onClick={handleDownloadXLSX}>
            Download
          </button>
        </div>
        <div>
          <MantineReactTable
            columns={tableColumns}
            data={paginatedData}
            enableFullScreenToggle={false}
            enablePagination={false}
            enableColumnFilters={true}
            enableSorting={true}
            enableColumnOrdering={true}
            enableGlobalFilter={true}
            enableRowSelection={false}
            mantineTableBodyCellProps={{
              style: {
                backgroundColor: "#C8E3EC60",
                color: "#505050",
                border: "0.5px solid #fff",
                padding: "10px",
              },
            }}
            mantineTableHeadCellProps={{
              style: {
                backgroundColor: "#2d7d9f",
                fontSize: "14px",
                fontWeight: 500,
                color: "#fff",
                border: "1px solid #fff",
              },
            }}
            mantineTableBodyRowProps={(row) => ({
              style: {
                backgroundColor: row.index % 2 === 0 ? "#f9f9f9" : "#fff",
              },
            })}
          />
          <div className="pagination-container border p-2 d-flex flex-wrap justify-content-between align-items-center gap-3">
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: "14px" }}>Items per page:</span>
              <select
                className="form-select"
                style={{ width: "110px" }}
                value={pageSize}
                onChange={(e) => handlePageSizeChange(parseInt(e.target.value))}
              >
                <option value={5}>5 rows</option>
                <option value={10}>10 rows</option>
                <option value={20}>20 rows</option>
                <option value={50}>50 rows</option>
                <option value={100}>100 rows</option>
              </select>
            </div>
            <div className="d-flex justify-content-center align-items-center">
              <span style={{ fontSize: "14px" }}>
                {totalRows === 0
                  ? "Showing 0 to 0 of 0 entries"
                  : `Showing ${startRow} - ${endRow} of ${totalRows} entries`}
              </span>
            </div>

            <div className="d-flex justify-content-center align-items-center gap-3">
              <button
                className="previous-button"
                onClick={() => handlePageChange(page - 1)}
                disabled={page === 0}
              >
                Previous
              </button>
              <button
                className="add-button text-center justify-content-center"
                style={{ width: "100px" }}
                onClick={() => handlePageChange(page + 1)}
                disabled={(page + 1) * pageSize >= tableData.length}
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
